import { render, staticRenderFns } from "./FruitInventory.vue?vue&type=template&id=58244f69&scoped=true"
import script from "./FruitInventory.vue?vue&type=script&lang=js"
export * from "./FruitInventory.vue?vue&type=script&lang=js"
import style0 from "./FruitInventory.vue?vue&type=style&index=0&id=58244f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58244f69",
  null
  
)

export default component.exports